/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Health_InvalidInputs */

const id_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest tidak valid`)
};

const ms_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifes tidak sah`)
};

const da_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyldigt manifest`)
};

const de_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültiges Manifest`)
};

const en_us2_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid manifest`)
};

const es_es2_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifiesto inválido`)
};

const es_mx2_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifiesto inválido`)
};

const fil_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di-wastong manifest`)
};

const fr_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifeste invalide`)
};

const it_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest non valido`)
};

const hu_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érvénytelen manifest`)
};

const nl_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldig manifest`)
};

const no_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugyldig manifest`)
};

const pl_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieprawidłowy manifest`)
};

const pt_br2_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto inválido`)
};

const pt_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifesto inválido`)
};

const ro_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest nevalid`)
};

const fi_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virheellinen manifesti`)
};

const sv_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogiltigt manifest`)
};

const vi_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manifest không hợp lệ`)
};

const tr_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geçersiz manifest`)
};

const cs_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neplatný manifest`)
};

const bg_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Невалиден манифест`)
};

const ru_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недействительный манифест`)
};

const uk_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недійсний маніфест`)
};

const ar_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيان غير صالح`)
};

const hi_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अमान्य मेनिफ़ेस्ट`)
};

const th_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แมนิเฟสต์ไม่ถูกต้อง`)
};

const ja_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なマニフェスト`)
};

const zh_cn2_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效清单`)
};

const zh_hant1_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無效資訊清單`)
};

const ko_builds_health_invalid = /** @type {(inputs: Builds_Health_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 매니페스트`)
};

/**
* | output |
* | --- |
* | "Invalid manifest" |
*
* @param {Builds_Health_InvalidInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_health_invalid = /** @type {((inputs?: Builds_Health_InvalidInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Health_InvalidInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_health_invalid(inputs)
	if (locale === "ms") return ms_builds_health_invalid(inputs)
	if (locale === "da") return da_builds_health_invalid(inputs)
	if (locale === "de") return de_builds_health_invalid(inputs)
	if (locale === "en-US") return en_us2_builds_health_invalid(inputs)
	if (locale === "es-ES") return es_es2_builds_health_invalid(inputs)
	if (locale === "es-MX") return es_mx2_builds_health_invalid(inputs)
	if (locale === "fil") return fil_builds_health_invalid(inputs)
	if (locale === "fr") return fr_builds_health_invalid(inputs)
	if (locale === "it") return it_builds_health_invalid(inputs)
	if (locale === "hu") return hu_builds_health_invalid(inputs)
	if (locale === "nl") return nl_builds_health_invalid(inputs)
	if (locale === "no") return no_builds_health_invalid(inputs)
	if (locale === "pl") return pl_builds_health_invalid(inputs)
	if (locale === "pt-BR") return pt_br2_builds_health_invalid(inputs)
	if (locale === "pt") return pt_builds_health_invalid(inputs)
	if (locale === "ro") return ro_builds_health_invalid(inputs)
	if (locale === "fi") return fi_builds_health_invalid(inputs)
	if (locale === "sv") return sv_builds_health_invalid(inputs)
	if (locale === "vi") return vi_builds_health_invalid(inputs)
	if (locale === "tr") return tr_builds_health_invalid(inputs)
	if (locale === "cs") return cs_builds_health_invalid(inputs)
	if (locale === "bg") return bg_builds_health_invalid(inputs)
	if (locale === "ru") return ru_builds_health_invalid(inputs)
	if (locale === "uk") return uk_builds_health_invalid(inputs)
	if (locale === "ar") return ar_builds_health_invalid(inputs)
	if (locale === "hi") return hi_builds_health_invalid(inputs)
	if (locale === "th") return th_builds_health_invalid(inputs)
	if (locale === "ja") return ja_builds_health_invalid(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_health_invalid(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_health_invalid(inputs)
	return ko_builds_health_invalid(inputs)
});
export { builds_health_invalid as "builds.health.invalid" }